export default __webpack_public_path__ + "static/media/logo-qrcode.602faed2.svg";